import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TranslateModule } from '@ngx-translate/core';
import { TableComponentModule } from '../../main-view/table.module';
import { ButtonModule } from 'primeng-lts/button';
import { MenuModule } from 'primeng-lts/menu';
import { PanelModule } from 'primeng-lts/panel';
import { ScrollPanelModule } from 'primeng-lts/scrollpanel';
import { DossierContractsProgressGraphComponent } from './dossierContractsProgressGraph.component';
import { ChartModule } from 'primeng-lts/chart';

@NgModule({
  declarations: [DossierContractsProgressGraphComponent],
  imports: [
    TranslateModule,
    CommonModule,
    ChartModule,
    PanelModule,
    MenuModule,
    ButtonModule,
    ScrollPanelModule,
    TableComponentModule
  ],
  exports: [DossierContractsProgressGraphComponent]
})
export class DossierContractsProgressGraphModule {
}
